import Typography, { TypographyProps } from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

const LoggerWrapper = styled('div')(({ theme }) => ({
  borderColor: theme.palette.primary.main,
}));

const MyText = styled(Typography)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  fontSize: 2,
}));

const MyText2 = styled(Typography)<TypographyProps>(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.pxToRem(10),
}));

export default LoggerWrapper;
export { MyText, MyText2 };
